import { ServerComm } from '@gts-common/client';
import { ServiceCode } from '@gts-common/client-server';
export const serverComm = new ServerComm(ServiceCode.NEXT_SURVEY, {});
